import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, mergeProps as _mergeProps, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "mb-3" }
const _hoisted_2 = ["for"]
const _hoisted_3 = ["id", "aria-invalid"]
const _hoisted_4 = {
  value: "",
  disabled: ""
}
const _hoisted_5 = ["value"]
const _hoisted_6 = ["id", "type", "autocomplete", "placeholder", "aria-invalid"]
const _hoisted_7 = {
  key: 0,
  class: "invalid-feedback d-block"
}
const _hoisted_8 = {
  key: 0,
  class: "form-text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", {
      for: _ctx.id,
      class: "form-label"
    }, _toDisplayString(_ctx.label), 9, _hoisted_2),
    _createVNode(_component_Field, {
      name: _ctx.name,
      "model-value": _ctx.modelValue,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event)))
    }, {
      default: _withCtx(({ field, meta, errorMessage }) => [
        _createElementVNode("div", {
          class: _normalizeClass({ 'au-input-icon': !!_ctx.icon })
        }, [
          (_ctx.icon)
            ? (_openBlock(), _createElementBlock("i", {
                key: 0,
                class: _normalizeClass(['bi', _ctx.icon])
              }, null, 2))
            : _createCommentVNode("", true),
          (_ctx.options)
            ? (_openBlock(), _createElementBlock("select", _mergeProps({
                key: 1,
                id: _ctx.id
              }, field, {
                class: ["form-select", _ctx.stateClass(meta, errorMessage)],
                "aria-invalid": _ctx.isInvalid(meta, errorMessage)
              }), [
                _createElementVNode("option", _hoisted_4, _toDisplayString(_ctx.placeholder), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: String(option.value),
                    value: option.value
                  }, _toDisplayString(option.label), 9, _hoisted_5))
                }), 128))
              ], 16, _hoisted_3))
            : (_openBlock(), _createElementBlock("input", _mergeProps({
                key: 2,
                id: _ctx.id
              }, field, {
                type: _ctx.type,
                autocomplete: _ctx.autocomplete,
                placeholder: _ctx.placeholder,
                class: ["form-control", _ctx.stateClass(meta, errorMessage)],
                "aria-invalid": _ctx.isInvalid(meta, errorMessage)
              }), null, 16, _hoisted_6))
        ], 2),
        (_ctx.isInvalid(meta, errorMessage))
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(errorMessage), 1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["name", "model-value"]),
    (_ctx.hint)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.hint), 1))
      : _createCommentVNode("", true)
  ]))
}